module.exports = __webpack_public_path__ + "6b217e92ea15e13ce9c6b31a23b781a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_06_mobile.jpg
// module id = 657
// module chunks = 0